import { Breadcrumb, Button } from "antd";
import DALayout from "../da-layout";
import "./daFinal.scss";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import OprationResult from "../../../auxiliary/opration/opration";
import { convertToJalaliWithoutTime } from "../../../../tools/tools";
import { useLocation } from "react-router-dom";

const DAFinal = () => {
  const [t] = useTranslation("global");
  const location = useLocation();

  return (
    <DALayout>
      <div className="container-main container-da">
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("deliveryArea.title") }]}
          />
          <div className="title-page">
            <h3>{t("deliveryArea.title")}</h3>
            <p></p>
          </div>
        </div>
        <div className="g-layout-content">
          <Content className="g-layout-main da-container">
            <div className="g-format-page">
              <div className="g-body-format-page">
                <div className="da-final-container">
                  <OprationResult
                    isSucess={true}
                    list={[
                      {
                        label: "تاریخ و ساعت",
                        value: (
                          <>
                            {/* <span dir="ltr">{convertToJalaliWithoutTime(location?.state?.swChange?.Date)}</span> */}
                            <span dir="ltr">{convertToJalaliWithoutTime(new Date().toISOString())}</span>
                          </>
                        ),
                      },
                      {
                        label: "نوع سرویس",
                        value: location?.state?.daChange?.ServiceType,
                      },
                      {
                        label: "شماره سیم کارت",
                        value: location?.state?.daChange?.MSISDN,
                      },
                      {
                        label: "شماره کیت جدید",
                        value: location?.state?.daChange?.NEWICCID,
                      },
                      {
                        label: "کد پیگیری",
                        value: location?.state?.daChange?.StrFollwUpCode,
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="g-footer-format-page">
                <div className="holder-button">
                  <Button
                    className="btn-normal btn-print"
                    onClick={() => {
                      window.print();
                    }}
                    type="default"
                    icon={<i className="icon-print"></i>}
                  >
                    چاپ رسید
                  </Button>
                </div>
              </div>
            </div>
          </Content>
        </div>
      </div>
    </DALayout>
  );
};

export default DAFinal;
